<div class="container">
    <div class="h-screen flex items-center justify-center">
        <p class="mx-10 p-4 font-semibold text-3xl">
            {{ 'TryLater' | translate }}
        </p>
    </div>
</div>